import type { PublicSiteSettings } from "@friends-church-dvr/contracts";

export const environmentLabel = (environment: string): string | null =>
  environment === "preview" ? "Preview" : null;

export const productionPreviewUrl = (environment: string): string | null =>
  environment === "production" ? "https://dvr-preview.friendschurch.online" : null;

export const siteIconLinks = (
  faviconUrl: string | null,
  shortcutIconUrl = faviconUrl,
): ReadonlyArray<{
  rel: "icon" | "apple-touch-icon";
  href: string;
}> =>
  faviconUrl && shortcutIconUrl
    ? [
        { rel: "icon", href: faviconUrl },
        { rel: "apple-touch-icon", href: shortcutIconUrl },
      ]
    : faviconUrl
      ? [{ rel: "icon", href: faviconUrl }]
      : shortcutIconUrl
        ? [{ rel: "apple-touch-icon", href: shortcutIconUrl }]
        : [];

export const containedIconRect = (
  sourceWidth: number,
  sourceHeight: number,
  canvasSize = 512,
  padding = 48,
): { x: number; y: number; width: number; height: number } => {
  const availableSize = canvasSize - padding * 2;
  if (
    sourceWidth <= 0 ||
    sourceHeight <= 0 ||
    canvasSize <= 0 ||
    padding < 0 ||
    availableSize <= 0
  ) {
    throw new Error("invalid_icon_dimensions");
  }
  const scale = Math.min(availableSize / sourceWidth, availableSize / sourceHeight);
  const width = sourceWidth * scale;
  const height = sourceHeight * scale;
  return {
    x: (canvasSize - width) / 2,
    y: (canvasSize - height) / 2,
    width,
    height,
  };
};

export const siteDocumentTitle = (
  settings: Pick<PublicSiteSettings, "organizationName" | "siteName">,
  environment: string,
): string => {
  const label = environmentLabel(environment);
  return [settings.organizationName, settings.siteName, label].filter(Boolean).join(" · ");
};
